import React, { useState, useMemo } from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Paper,
  IconButton,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import reportsData from "./reportsData";

const ReportsPage = () => {
  const categories = ["Favourites", ...Object.keys(reportsData)];
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const [favourites, setFavourites] = useState(new Set());

  // Combine all reports with category info
  const allReports = useMemo(() => {
    const combined = [];
    for (const [category, reports] of Object.entries(reportsData)) {
      for (const report of reports) {
        combined.push({ ...report, category });
      }
    }
    return combined;
  }, []);

  const toggleFavourite = (reportId) => {
    setFavourites((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(reportId)) newSet.delete(reportId);
      else newSet.add(reportId);
      return newSet;
    });
  };

  const reportsToShow = useMemo(() => {
    if (selectedCategory === "Favourites") {
      return allReports.filter((report) => favourites.has(report.id));
    }
    return reportsData[selectedCategory] || [];
  }, [selectedCategory, favourites, allReports]);

  return (
    <Box bgcolor="#f7f7f7" height={"auto"}>
      <Paper elevation={1} sx={{ display: "flex", minHeight: "80vh" }}>
        {/* Sidebar */}
        <Box maxWidth="250px" bgcolor="" borderRight="1px solid #ddd">
          <List>
            {categories.map((category) => (
              <ListItemButton
                key={category}
                selected={selectedCategory === category}
                onClick={() => setSelectedCategory(category)}
              >
                <ListItemText primary={category} />
              </ListItemButton>
            ))}
          </List>
        </Box>

        {/* Content */}
        <Box flex={1} p={3}>
          <Typography variant="h6" gutterBottom>
            {selectedCategory}
          </Typography>
          {reportsToShow.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              No reports available in this section.
            </Typography>
          ) : (
            reportsToShow.map((report, index) => (
              <Paper
                key={report.id}
                elevation={1}
                sx={{
                  p: 2,
                  mb: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {report.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {report.description}
                  </Typography>
                </Box>
                <IconButton onClick={() => toggleFavourite(report.id)}>
                  {favourites.has(report.id) ? (
                    <StarIcon color="warning" />
                  ) : (
                    <StarBorderIcon />
                  )}
                </IconButton>
              </Paper>
            ))
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default ReportsPage;
